import { atom, selector } from 'recoil'
import { recoilPersist } from 'recoil-persist'
import { IFavUsers } from 'types'
const { persistAtom } = recoilPersist()

export const favUsers = atom({
  key: 'favUsers',
  default: {} as IFavUsers,
  effects_UNSTABLE: [persistAtom]
})

type isFavFunction = (a: string) => boolean

export const isFavUser = (userId: number) =>
  selector({
    key: `isFavUser_${userId}`,
    get: ({ get }) => {
      const allUsers = get(favUsers)
      return allUsers[userId]
    }
  })
